import { render, staticRenderFns } from "./ReturnDocListFinal.vue?vue&type=template&id=bf34acdc&"
import script from "./ReturnDocListFinal.vue?vue&type=script&lang=js&"
export * from "./ReturnDocListFinal.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports